(() => {
  const init = (root) => {
    if (!root || root.dataset.chromeInitialized === 'true') return;
    root.dataset.chromeInitialized = 'true';
    const prepareExternalLink = (link) => {
      if (!link?.href) return;
      const url = new URL(link.href, window.location.href);
      if (!/^https?:$/.test(url.protocol) || url.origin === window.location.origin || url.hostname === 'be-search.biz') return;
      link.target = '_blank';
      link.relList.add('noopener', 'noreferrer');
    };
    document.querySelectorAll('.be-search-top a[href], footer a[href], #menu-drawer a[href]').forEach(prepareExternalLink);
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.be-search-top a[href], footer a[href], #menu-drawer a[href]');
      prepareExternalLink(link);
    }, true);

    const siteHeader = root.querySelector('[data-site-header]');
    const topicsBar = root.querySelector('[data-topics-bar]');
    const topicsMessages = topicsBar ? [...topicsBar.querySelectorAll('[data-topics-message]')] : [];
    if (topicsMessages.length > 1) {
      let activeTopic = 0;
      let topicsVisible = false;
      let topicsTimer = null;
      const stopTopics = () => {
        window.clearInterval(topicsTimer);
        topicsTimer = null;
      };
      const syncTopics = () => {
        stopTopics();
        if (!topicsVisible || document.hidden || !root.isConnected) return;
        topicsTimer = window.setInterval(() => {
          const previousTopic = activeTopic;
          activeTopic = (activeTopic + 1) % topicsMessages.length;
          topicsMessages.forEach((message, index) => {
            const active = index === activeTopic;
            message.classList.toggle('is-active', active);
            message.classList.toggle('is-entering', active);
            message.classList.toggle('is-leaving', index === previousTopic);
            message.setAttribute('aria-hidden', String(!active));
          });
        }, 4500);
      };
      const topicsObserver = new IntersectionObserver(([entry]) => {
        topicsVisible = entry.isIntersecting;
        syncTopics();
      });
      topicsObserver.observe(topicsBar);
      document.addEventListener('visibilitychange', syncTopics);
      document.addEventListener('shopify:section:unload', function unloadTopics(event) {
        if (!event.target.contains(root)) return;
        stopTopics();
        topicsObserver.disconnect();
        document.removeEventListener('visibilitychange', syncTopics);
        document.removeEventListener('shopify:section:unload', unloadTopics);
      });
    }
    const headerToggle = root.querySelector('[data-header-menu-toggle]');
    const fixedHeaderNav = root.querySelector('[data-fixed-header-nav]');
    const desktopHeader = window.matchMedia('(min-width: 901px)');
    const headerThreshold = siteHeader ? siteHeader.offsetTop + siteHeader.offsetHeight : 0;
    let headerTicking = false;
    const closeFixedHeaderNav = () => {
      siteHeader?.classList.remove('is-menu-open');
      headerToggle?.setAttribute('aria-expanded', 'false');
      headerToggle?.setAttribute('aria-label', 'メニューを開く');
    };
    const updateStickyHeader = () => {
      headerTicking = false;
      if (!siteHeader) return;
      const shouldFix = window.scrollY > headerThreshold;
      if (desktopHeader.matches) {
        siteHeader.classList.remove('is-mobile-fixed');
        siteHeader.classList.toggle('is-fixed', shouldFix);
        if (!shouldFix) closeFixedHeaderNav();
      } else {
        siteHeader.classList.remove('is-fixed', 'is-menu-open');
        siteHeader.classList.toggle('is-mobile-fixed', shouldFix);
      }
    };
    window.addEventListener('scroll', () => {
      if (headerTicking) return;
      headerTicking = true;
      window.requestAnimationFrame(updateStickyHeader);
    }, { passive: true });
    desktopHeader.addEventListener?.('change', updateStickyHeader);
    headerToggle?.addEventListener('click', () => {
      if (desktopHeader.matches) {
        if (!siteHeader?.classList.contains('is-fixed')) return;
        const isOpen = siteHeader.classList.toggle('is-menu-open');
        headerToggle.setAttribute('aria-expanded', String(isOpen));
        headerToggle.setAttribute('aria-label', isOpen ? 'メニューを閉じる' : 'メニューを開く');
        return;
      }
      document.querySelector('body.be-site-chrome header-drawer summary.header__icon--menu')?.click();
    });
    const nativeDrawerDetails = document.querySelector('body.be-site-chrome header-drawer details.menu-drawer-container');
    nativeDrawerDetails?.addEventListener('toggle', () => {
      if (!nativeDrawerDetails.open && !desktopHeader.matches) {
        nativeDrawerDetails.querySelectorAll('details').forEach((details) => {
          details.open = false;
          details.classList.remove('menu-opening');
          details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
        });
        nativeDrawerDetails.querySelectorAll('.submenu-open').forEach((panel) => panel.classList.remove('submenu-open'));
      }
      if (nativeDrawerDetails.open && !desktopHeader.matches) {
        const categories = nativeDrawerDetails.querySelector('#Details-menu-drawer-top-categories');
        if (categories) {
          categories.open = true;
          categories.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
        }
      }
      siteHeader?.classList.toggle('is-mobile-menu-open', nativeDrawerDetails.open);
      headerToggle?.setAttribute('aria-expanded', String(nativeDrawerDetails.open));
      headerToggle?.setAttribute('aria-label', nativeDrawerDetails.open ? 'メニューを閉じる' : 'メニューを開く');
    });
    fixedHeaderNav?.addEventListener('click', (event) => {
      if (event.target.closest('a[href]')) closeFixedHeaderNav();
    });
    updateStickyHeader();

    let concernsScrollFrame;
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const url = new URL(link.href, location.href);
      const target = root.querySelector('#concerns');
      if (!target || url.origin !== location.origin || url.pathname !== location.pathname || url.hash !== '#concerns') return;
      event.preventDefault();
      closeFixedHeaderNav();
      const scrollToConcerns = () => window.requestAnimationFrame(() => {
        window.cancelAnimationFrame(concernsScrollFrame);
        const startY = window.scrollY;
        const margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        const duration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 650;
        const started = performance.now();
        const step = (now) => {
          const progress = duration ? Math.min(1, (now - started) / duration) : 1;
          const eased = 1 - Math.pow(1 - progress, 3);
          // Sticky-header activation can change the document flow during travel.
          const destination = Math.max(0, window.scrollY + target.getBoundingClientRect().top - margin);
          window.scrollTo({ top: startY + (destination - startY) * eased, behavior: 'instant' });
          if (progress < 1) concernsScrollFrame = window.requestAnimationFrame(step);
        };
        concernsScrollFrame = window.requestAnimationFrame(step);
        history.pushState(null, '', url.hash);
      });
      if (nativeDrawerDetails?.open) {
        const afterClose = () => {
          if (nativeDrawerDetails.open) return;
          nativeDrawerDetails.removeEventListener('toggle', afterClose);
          scrollToConcerns();
        };
        nativeDrawerDetails.addEventListener('toggle', afterClose);
        nativeDrawerDetails.querySelector('summary.header__icon--menu')?.click();
      } else scrollToConcerns();
    });

    const headerWishlist = root.querySelector('[data-header-wishlist]');
    if (headerWishlist) {
      const syncWishlistIndicator = () => {
        const hasLiveItems = [...document.querySelectorAll('.wishlist-hero-items-count')].some((counter) =>
          counter.classList.contains('wishlist-hero-items-count-exists') || Number.parseInt(counter.textContent || '0', 10) > 0);
        if (headerWishlist.classList.contains('has-items') !== hasLiveItems) headerWishlist.classList.toggle('has-items', hasLiveItems);
      };
      syncWishlistIndicator();
      document.querySelectorAll('.wishlist-hero-header-icon, [data-header-wishlist]').forEach((link) => {
        new MutationObserver(syncWishlistIndicator).observe(link, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          characterData: true,
          subtree: true,
        });
      });
      document.addEventListener('wishlist-hero-wishlist-updated', syncWishlistIndicator);
    }

    document.querySelectorAll('body.be-site-chrome #menu-drawer .be-top-drawer-menu details > summary').forEach((summary) => {
      summary.addEventListener('click', (event) => {
        event.stopImmediatePropagation();
        window.requestAnimationFrame(() => {
          summary.setAttribute('aria-expanded', String(summary.parentElement?.open === true));
        });
      }, true);
    });

    const cartCountBadge = root.querySelector('[data-cart-count-badge]');
    if (cartCountBadge) {
      let cartRequest = 0;
      const syncCartCount = async () => {
        const request = ++cartRequest;
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
          if (!response.ok) return;
          const cart = await response.json();
          if (request !== cartRequest || !Number.isInteger(cart.item_count) || cart.item_count < 0) return;
          cartCountBadge.textContent = String(cart.item_count);
          cartCountBadge.classList.toggle('is-empty', cart.item_count === 0);
          cartCountBadge.closest('a')?.setAttribute('aria-label', `カート・${cart.item_count}点`);
        } catch (error) { /* Keep the last Shopify count on network failure. */ }
      };
      syncCartCount();
      window.addEventListener('pageshow', syncCartCount);
      window.addEventListener('focus', syncCartCount);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, syncCartCount);
    }

  };
  const initAll = () => document.querySelectorAll('[data-site-header]').forEach(header => init(header.closest('.be-search-top')));
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initAll) : initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
